export default __webpack_public_path__ + "static/media/ImpulseMomentumImg.045d3f09.jpg";